import { Box, Typography } from "@mui/material";

const ArrowStatus = ({ value, color }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4px 0px !important",
        margin: "0 !important",
      }}
    >
      <Typography variant="body1" color={color} fontWeight="bold">
        {value}
      </Typography>
      <Box sx={{
        width: 0,
        height: 0,
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderBottom: `7px solid ${color}`,
      }} />
    </Box>
  );
};

export default ArrowStatus;
